import React from 'react';
import {
    DateField,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';


const useStyles = makeStyles({
    ok: { color: 'green' },
    error: { color: 'red' },
    warning: { color: 'orange' },
});

const ActiveField = props => {
    const classes = useStyles();

    return (
        <DateField
            className={classnames({
                [classes.ok]: props.record[props.reference] === "valid",
                [classes.warning]: props.record[props.reference] === "expiring_soon",
                [classes.error]: props.record[props.reference] === "expired"
            })}
            {...props}
        />
    );
};

export default ActiveField;
